var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterDarkMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    xmlSpace: "preserve",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA70lEQVR4nO3YWw6CMBAF0O7DR9Sd6wdsQF2A7sXW3hl0B5r6SJTwIeIgkHuS+YGkMKUlN3WOiIiGJITzApAckPioPF1zfeL9aQ5oAPRSKu/9aeb6IkZd3V9c1iIySgXIJl2LUZemDwdkXzGDjUpExs/xi6KY/np8QPatNKKqE+NGdm0trU36KqkhQLatLC2Dze4rZvHQq83+8vvNAD3eS7LU4O0mERF1TWBqHlpqhkFotE/N0k76tU/NYpt+vxWZmjsoMDUTEZUxmXZJ/Od5bh2fhkb781ytUQ3Sr/15rtZppH76ZTLtosBkSkRE7s0VVgGU/Te/u8kAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDarkMode);
export default __webpack_public_path__ + "static/media/filter_dark_mode.4f4024a485dc6ceff0e190ad9d7dae2f.svg";
export { ForwardRef as ReactComponent };